// Small display helpers shared across the campaigns drill-down.

import { THEME } from "../../constants";
import chroma from "chroma-js";

// Company brand colour reused for accents (rails, coloured campaign names,
// group-header dots) so grid and list read as the same company.
// ponytail: very pale colour-hash outputs can still read a bit low-contrast as
// text; darken(0.6) keeps them legible on white without going muddy.
export const companyAccent = (name) =>
  chroma(THEME.companyColorHash.hex(name)).darken(0.6).hex();

export const formatPeriod = (start, end) =>
  [start, end].filter(Boolean).join(" → ") || "—";

// Portfolio-wide KPIs shown in the (level-agnostic) header at every drill-down
// level, so the header identity stays constant — only the title path changes.
export const portfolioMetrics = (contracts = []) => [
  { value: contracts.length, label: "Campaigns" },
  {
    value: contracts.reduce((acc, c) => acc + (c.total_sites ?? 0), 0),
    label: "Sites",
  },
];
